import type { JsonObject } from "../../../api/http/jsonDecoding";
import type { ItemChange, ItemKind } from "../../../api/content/reviewDecoders";
import { readableJsonText } from "../../../shared/formatting/readableJson";

/**
 * The text fields a review shows as a line diff, per item kind: what people write and
 * reviewers read line by line. Other fields stay "changed fields". Pure.
 */
export const REVIEWED_TEXT_FIELDS: Readonly<Partial<Record<ItemKind, readonly string[]>>> = {
  prompt: ["text"],
  skill: ["description", "body"],
  artifact: ["content"],
};

/** Every field name above once, for the field names' translations. */
export const REVIEWED_TEXT_FIELD_NAMES: readonly string[] = [...new Set(Object.values(REVIEWED_TEXT_FIELDS).flat())];

/** The changed text fields of an item, in the order above. */
export function changedTextFields(item: ItemChange): readonly string[] {
  const changed = new Set(item.changedFields ?? []);
  return (REVIEWED_TEXT_FIELDS[item.kind] ?? []).filter((field) => changed.has(field));
}

/** A field as text: a string as it is, any other JSON (an artifact's JSON content) in the
 * readable layout,
 * and nothing when the version or the field is missing. */
export function definitionFieldText(definition: JsonObject | null, field: string): string {
  const value = definition?.[field];
  if (value === undefined || value === null) {
    return "";
  }
  return typeof value === "string" ? value : readableJsonText(value);
}
